import { render, staticRenderFns } from "./CancelAccount.vue?vue&type=template&id=746ca562&scoped=true"
import script from "./CancelAccount.vue?vue&type=script&lang=js"
export * from "./CancelAccount.vue?vue&type=script&lang=js"
import style0 from "./CancelAccount.vue?vue&type=style&index=0&id=746ca562&prod&lang=css"
import style1 from "./CancelAccount.vue?vue&type=style&index=1&id=746ca562&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746ca562",
  null
  
)

export default component.exports